export default __webpack_public_path__ + "static/media/landing-write-article.292be862.svg";